import React, { useContext } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Button, message, Upload } from "antd";
import config from "./../services/config.json";
import ImgCrop from "antd-img-crop";
import { context } from "../context/context";

const TextEditorUploader = () => {
  const { setLinkAddress } = useContext(context);
  const props = {
    name: "objectKey",
    action: `${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65b532c24387fe1bbbc904cf`,
    headers: {
      authorization: "authorization-text",
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        // console.log(info.file, info.fileList);
        setLinkAddress(info.file.response.files[0].address);
      }
      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };
  return (
    <>
      <ImgCrop rotationSlider>
        <Upload {...props}>
          <Button icon={<UploadOutlined />}>آپلود تصویر</Button>
        </Upload>
      </ImgCrop>
    </>
  );
};

export default TextEditorUploader;
